export default function Exclusives() {
  return <div>Destacados</div>;
}
